<fieldset class="filter-group type-compact type-select toggle-group">
    <div class="toggle-group__bar" (click)="expanded = !expanded" [ngClass]="{'is--active': expanded}">
        <legend class="filter-group__bar__title">{{aggregation.Meta.alias || aggregation.Meta.title}}:</legend>
        <button type="button" class="block-group-toggle-button type-small" [ngClass]="{'is--active': expanded}">
            <span class="icon is--icon-plus">
                <svg class="icon-svg">
                    <use xlink:href="/assets/gfx/svg-sprite.svg#icon-plus"></use>
                </svg>
            </span>

            <span class="icon is--icon-min">
                <svg class="icon-svg">
                    <use xlink:href="/assets/gfx/svg-sprite.svg#icon-min"></use>
                </svg>
            </span>
        </button>
    </div>

    <div class="filter-toggle-wrapper">

        <div class="switch-select">
            <span class="icon is--icon-angle-down">
                <svg class="icon-svg">
                    <use xlink:href="/assets/gfx/svg-sprite.svg#icon-angle-down"></use>
                </svg>
            </span>

            <select class="" id="" [(ngModel)]="selectedVal" (ngModelChange)="valueChanged($event)">
                <option value="">
                    Make a choice
                </option>

                <option *ngFor="let b of aggregation.Items" [ngValue]="b">
                        {{!b.To && b.From ? '>' : ''}} {{b.From | words}} {{b.From && !b.To ? '' : !b.From && b.To ? '<' : '-'}} {{b.To | words}}
                </option>
            </select>
        </div>
    </div>
</fieldset>
